import { Image } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { Card } from '@hero/atoms';

const ModalBody = styled.div`
  margin-top: 16px;
  a {
    color: var(--color-fg-weak);
  }
`;

const ListHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const ContentList = styled.ul`
  display: ${({ length }) => (length === 1 ? 'block' : 'grid')};
  grid-column-gap: 8px;
  grid-gap: 24px;
  grid-row-gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  margin-bottom: 16px;
  margin-top: 8px;
`;

const ContentItemImage = styled(Image)`
  border-radius: var(--size-border-radius-md);
`;

const ContentItemHeader = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 16px;
  width: ${({ length }) => (length === 1 ? '100%' : '240px')};

  .card-wrapper {
    padding: 4px;
  }
`;

const ContentItemSelectBadge = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 2px solid var(--color-bg-strong);
  border-radius: 2px;
  display: flex;
  height: 18px;
  justify-content: center;
  width: 18px;

  svg,
  path {
    fill: var(--color-accent-secondary-weaker);
  }
`;

const ContentItem = styled(Card)`
  border: 1px solid var(--color-accent-secondary-weaker);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 8px;
  position: relative;

  ${({ active }) =>
    active &&
    css`
      border: 1px solid var(--color-accent-primary-default);

      ${ContentItemSelectBadge} {
        background: var(--color-accent-primary-default);
        border: 2px solid var(--color-accent-primary-default);

        svg,
        path {
          fill: var(--color-bg-body);
        }
      }
    `}
`;

const ContentItemBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const ListHeaderRightContent = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const ContentContextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`;

const MoreInformationModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: hidden;
  text-align: left;
`;

export {
  ContentContextWrapper,
  ContentItem,
  ContentItemBody,
  ContentItemHeader,
  ContentItemImage,
  ContentItemSelectBadge,
  ContentList,
  ListHeader,
  ListHeaderRightContent,
  ModalBody,
  MoreInformationModalBody
};
